import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { Colligate } from "../types";

export const GET_ITEM_QUERY = print(gql`
  query TeachingAreaConversion($teachingAreaConversionId: Int!) {
    TeachingAreaConversion(id: $teachingAreaConversionId) {
      id
      colligate {
        id
        databaseName
        description
        active
        partnerVisibleName
        createdAt
        updatedAt
      }
      idColligate
      databaseName
      idArea
      teachingAreaName
      createdAt
      updatedAt
    }
  }
`);

export interface GetItemGql {
  TeachingAreaConversion: {
    id: number;
    colligate: Colligate;
    databaseName: string;
    idColligate: number;
    idArea: string;
    teachingAreaName: string;
    createdAt: Date;
    updatedAt: Date;
  };
}
